import { MapPin, Phone, Mail, MessageCircle, Star, FileText } from "lucide-react";
import { Reveal } from "./Reveal";
import { ADDRESS, GSTIN, PHONE_DISPLAY, EMAIL, GBP_URL, waLink } from "../data";
import { useLang } from "../i18n";

export const Location = () => {
  const { s } = useLang();
  return (
  <section id="contact" className="relative bg-cream py-24 sm:py-32" data-testid="contact-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-peacock font-semibold" data-testid="contact-overline">
          {s.location.overline}
        </p>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold text-maroon tracking-tight" data-testid="contact-heading">
          {s.location.heading}
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-7">
          <div className="overflow-hidden rounded-2xl border border-maroon/10 shadow-lg shadow-maroon/5" data-testid="map-embed">
            <iframe
              title="Shri Jamuna Dham location map — Chaitanya Vihar, Vrindavan"
              src="https://maps.google.com/maps?q=Chaitanya%20Vihar%2C%20Vrindavan%2C%20Uttar%20Pradesh%20281121&t=&z=15&ie=UTF8&iwloc=&output=embed"
              className="h-[420px] w-full"
              loading="lazy"
            />
          </div>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-5">
          <div className="flex h-full flex-col gap-4">
            <div className="rounded-2xl bg-maroon p-7 text-cream" data-testid="address-card">
              <MapPin size={22} className="text-saffron" />
              <p className="mt-4 font-display text-xl font-bold">Shri Jamuna Dham</p>
              <p className="mt-2 text-sm leading-relaxed text-cream/80">{ADDRESS}</p>
              <p className="mt-3 flex items-center gap-2 text-xs text-cream/60">
                <FileText size={13} /> GSTIN: {GSTIN}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <a
                href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`}
                data-testid="contact-call-button"
                className="flex items-center gap-3 rounded-2xl border border-maroon/15 p-5 transition-colors duration-300 hover:border-saffron"
              >
                <Phone size={18} className="shrink-0 text-peacock" />
                <span className="text-sm font-semibold text-ink">{PHONE_DISPLAY}</span>
              </a>
              <a
                href={`mailto:${EMAIL}`}
                data-testid="contact-email-button"
                className="flex items-center gap-3 rounded-2xl border border-maroon/15 p-5 transition-colors duration-300 hover:border-saffron"
              >
                <Mail size={18} className="shrink-0 text-peacock" />
                <span className="break-all text-sm font-semibold text-ink">{EMAIL}</span>
              </a>
              <a
                href={waLink("Namaste! I have a question about Shri Jamuna Dham, Vrindavan.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-button"
                className="flex items-center gap-3 rounded-2xl border border-maroon/15 p-5 transition-colors duration-300 hover:border-saffron"
              >
                <MessageCircle size={18} className="shrink-0 text-[#25D366]" />
                <span className="text-sm font-semibold text-ink">{s.location.whatsapp}</span>
              </a>
              <a
                href={GBP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-google-business-link"
                className="flex items-center gap-3 rounded-2xl border border-maroon/15 p-5 transition-colors duration-300 hover:border-saffron"
              >
                <Star size={18} className="shrink-0 text-gold" />
                <span className="text-sm font-semibold text-ink">{s.location.google}</span>
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
